<template>
  <div
    id="history"
    class="page"
  >
    <template v-if="!loading">
      <Banner :banner="page.banner" />
      <section
        id="content_section"
        class="container bg-white text-left"
      >
        <div class="row">
          <div class="pt-4 pb-5 col-lg-12">
            <Breadcrumb :items="[{ name: page.title, url: path }]" />
            <div class="content py-4">
              <div
                v-if="data && data.data"
                v-lazy-container="{ selector: '.thumb' }"
                class="grid container"
              >
                <div
                  v-for="(item, i) in data.data"
                  :key="i"
                  class="row pt-5"
                >
                  <div class="col-md-2 col-2 order-md-2 text-center">
                    <img
                      v-view.once
                      :src="getAssetLink(item.icon)"
                      border="0"
                      width="70"
                      class="animated"
                      :class="(i % 2 === 0)? 'fadeInRight':'fadeInLeft'"
                    >
                  </div>
                  <div
                    class="col-md-5 col-10 pt-3 bg-light"
                    :class="(i % 2 === 0)? 'order-md-1':'order-md-3'"
                  >
                    <a
                      v-if="item.image"
                      :id="`gallery_photo_${item.id}`"
                      class="d-block gallery_photo_trigger"
                      data-fancybox="gallery"
                      :data-options="fancyOptions"
                      :data-caption="`${item.year}: ${item.body}`"
                      :href="getAssetLink(item.image)"
                    >
                      <img
                        :id="`gallery_photo_thumb_${item.id}`"
                        class="thumb w-100"
                        :src="getAssetLink(item.image)"
                      >
                    </a>
                    <div
                      class="my-3"
                      v-html="item.body"
                    />
                    <h6 class="d-none d-block d-md-none mb-3">
                      {{ item.year }}
                    </h6>
                  </div>
                  <div
                    class="col-md-5 col-10 mt-3 d-none d-md-block p-0"
                    :class="(i % 2 !== 0)?'order-md-1 text-right':'order-md-3 text-left'"
                  >
                    <h6>{{ item.year }}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        id="donate_btn_section"
        class="container bg-white py-4 clearfix d-none d-md-block"
      >
        <DonateBtn
          v-view.once
          class="animated fadeInRight"
        />
      </section>
    </template>
  </div>
</template>
<script>
import Banner from "@/components/Banner.vue";
import DonateBtn from "@/components/DonateBtn.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
// import fancyBox from "vue-fancybox";

export default {
  name: "History",
  components: { Banner, DonateBtn, Breadcrumb },
  data() {
    let to = this.$router.history.current;
    return {
      // default
      path: to.path,
      loading: true,
      page: {
        // Default Settings for page
        sidemenu: null,
        banner: null,
        title: this.$t("page.history")
      },
      fancyOptions: this.getImageOptions(),
      data: null
    };
  },
  mounted() {
    this.$http
      .get(this.path)
      .then(response => {
        if (response.data.success) {
          this.data = response.data.data;

          this.page.banner = this.data.image;
          this.page.title =
            this.getDataValue("name", this.data) || this.page.title;
          this.page.heading =
            this.getDataValue("headline", this.data) || this.page.heading;
          this.$route.meta.title = this.page.title;
          this.$route.meta.desc = this.data.desc;
          this.$meta().refresh(); // Important!
        } else {
          if (typeof response.data == "string") {
            throw new Error(response.data);
          } else {
            throw new Error(response.data.error);
          }
        }
      })
      .catch(error => {
        let response = error.response;
        if (response && (response.status === 404 || response.status === 401)) {
          this.$router.replace("/404");
        }
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    getImageOptions() {
      return JSON.stringify({
        loop: true,
        thumbs: { autoStart: true, axis: "x" },
        buttons: ["slideShow", "thumbs", "close"]
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.page#history {
  .order-md-3.text-left > h6 {
    margin-left: -25px;
    margin-top: 10px;
    margin-bottom: 10px;
    opacity: 0.7;
  }
  .order-md-1.text-right > h6 {
    margin-right: -25px;
    margin-top: 10px;
    margin-bottom: 10px;
    opacity: 0.7;
  }
}
</style>